import {
  Waves,
  Eye,
  Sparkle,
  Sparkles,
  Hand,
  Eraser,
  Gem,
  Fingerprint,
  Flower2,
  Feather,
  Sun,
  Zap,
  Scissors,
  Heart,
  Droplet,
  Star,
  Brush,
  Flower,
} from "lucide-react";

export const ICONS = {
  Waves,
  Eye,
  Sparkle,
  Sparkles,
  Hand,
  Eraser,
  Gem,
  Fingerprint,
  Flower2,
  Feather,
  Sun,
  Zap,
  Scissors,
  Heart,
  Droplet,
  Star,
  Brush,
  Flower,
};

export const ICON_OPTIONS = Object.keys(ICONS);

export function getIcon(name) {
  return ICONS[name] || Sparkles;
}

const WA_NUMBER = "5511995470626";

export function whatsappLink(modalityTitle, consult = false) {
  const base = `https://wa.me/${WA_NUMBER}`;
  const msg = consult
    ? `Olá! Vim pelo catálogo digital do Studio da Beleza Bruna Reis e gostaria de consultar os valores de ${modalityTitle}.`
    : `Olá! Vim pelo catálogo digital do Studio da Beleza Bruna Reis e gostaria de saber mais sobre ${modalityTitle}.`;
  return `${base}?text=${encodeURIComponent(msg)}`;
}

export function whatsappGeneral(number) {
  return `https://wa.me/${number || WA_NUMBER}?text=${encodeURIComponent(
    "Olá! Vim pelo catálogo digital do Studio da Beleza Bruna Reis e gostaria de agendar um horário."
  )}`;
}
